import { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Button from 'components/button'
import Range from 'components/range'
import useLocalStorage from 'hooks/use-local-storage'
import textServices from 'services/text-services'
import { SectionCongrats } from 'theme/congrats'
import { useSession } from '../../contexts/session-context'
import { Crown } from '../../theme/profile'

const Congrats = () => {
  const [data, setData] = useState<any>(null)
  const [range, setRange] = useState<{ level: { id: number; name: string; imageUrl: string } } | null>(null)
  const history = useHistory()
  const [{ user }, { setPoints }] = useSession()
  const [lPrize, , removeLPrize] = useLocalStorage('prize', undefined as any)
  const [lSticker, , removeLSticker] = useLocalStorage('sticker', undefined as any)
  const [lRange] = useLocalStorage('range', undefined as any)

  useEffect(() => {
    if (lRange) {
      setRange(lRange)
      return history.push('/congrats/range')
    }
    if (lPrize) {
      setData(lPrize)
      setPoints(lPrize?.points || 0)
      removeLPrize()
    } else if (lSticker) {
      history.push(`/collections/sticker/redeem/congrats/${lSticker?.collectionId}/${lSticker?.code}`)
      removeLSticker()
    } else {
      history.push('/home')
    }
  }, [])

  if (range) return <Range data={range} history={history} name={user?.firstName} />

  return (
    data && (
      <SectionCongrats className="flex-1 p-4 flex flex-col items-center justify-between gap-4 text-black">
        <div className="uppercase text-center text-5xl md:mt-20">
          <h1 className="font-bold text-center" style={{ maxWidth: 'calc(100vw - 2rem)' }}>
            ¡{textServices.findByText('congrats/title', 'Eso ')}
            {user?.firstName}!{' '}
          </h1>
          <p className="mt-4 saira text-xl">
            {textServices.findByText('congrats/description', `SIGUE JUNTANDO ${POINTS_NAME} y sube en el ranking`)}
          </p>
        </div>
        <Crown className="w-48 h-48 flex justify-center items-center" style={{ backgroundSize: 'contain' }}>
          <p className="text-6xl font-bold">{data.points}</p>
        </Crown>
        <div className="w-full text-center px-4 text-xl mb-8">
          <Link to={textServices.findByText('config/prizes', '/prizes')}>
            <Button
              className="uppercase flex justify-center items-center"
              onClick={() =>
                gtag('event', 'Click', {
                  event_category: GTM_EVENT_CATEGORY,
                  event_label: 'CONGRATS - Ver los Premios',
                  value: '10'
                })
              }
            >
              <p className="text-sm"> {textServices.findByText('congrats/button1', 'Quiero ver los premios')}</p>
            </Button>
          </Link>
          <Link to="/redeem">
            <Button
              className="uppercase flex justify-center items-center mt-6"
              disabled
              onClick={() =>
                gtag('event', 'Click', {
                  event_category: GTM_EVENT_CATEGORY,
                  event_label: 'CONGRATS - Ingresar otro Código',
                  value: '10'
                })
              }
            >
              <p className="text-sm">{textServices.findByText('congrats/button2', 'QUIERO INGRESAR OTRO CÓDIGO')}</p>
            </Button>
          </Link>
        </div>
      </SectionCongrats>
    )
  )
}

export default Congrats
